import { useState, useEffect, memo } from "react";
import style from "./../index.module.scss";
import styleUi from "./AddFriend.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import apiManager from './../../ApiManager';

const AddFriend = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [friends, set_friends] = useState([]);
    const [filterUser, set_filterUser] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        setInProp(true);
        document.title = "朋友";
        apiManager.fetchGet(`user/friends/recommended`, {}, 0).then(res => {
            console.log("res", res)
            set_friends(res);
        })
    }, []);

    useEffect(() => {
        let _filterUser = [];
        if (searchTerm === "") {
            _filterUser = [...friends];
        } else {
            _filterUser = friends.filter(user =>
                user.user_friends_detail.user_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                user.user_friends_detail.user_id.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        /* _filterUser.sort((a, b) => {
            if (a.user_friends_status === b.user_friends_status) {
                return a.user_friends_detail.user_name.localeCompare(b.user_friends_detail.user_name, "zh-Hant");
            }
            return a.user_friends_status - b.user_friends_status;
        }); */
        set_filterUser(_filterUser);
    }, [searchTerm, friends]);


    const handleInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "AddFriend"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <img src="./assets/ui/back.png" onClick={() => setInProp(false)} />
                                    <YStyled.Span size={17} fontWeight={700}>新增好友</YStyled.Span>
                                    <img src="./assets/ui/back.png" />
                                </div>
                                <div className={styleUi.view}>
                                    <div className={styleUi.subHeader}>
                                        <YStyled.Span size={15} onClick={async (e) => {
                                            const currentDomain = window.location.origin; // 获取当前的域名和协议，例如 "http://localhost:3000"
                                            const invitePath = ``; // 你想要生成的路径
                                            const inviteLink = `${currentDomain}${invitePath}`; // 构造完整的邀请链接
                                            if (navigator.share) {
                                                try {
                                                    await navigator.share({
                                                        title: '快來加入 OOSA ! 跟你的夥伴一起在自然中探索、放鬆並且記錄一切美好回憶...',
                                                        //text: '分享描述',
                                                        url: inviteLink // 你想要分享的网址
                                                    });
                                                    console.log('分享成功');
                                                } catch (error) {
                                                    console.log('分享失败', error);
                                                }
                                            } else {
                                                navigator.clipboard.writeText(inviteLink).then(() => {
                                                    alert('己複製連結');
                                                }).catch(err => {
                                                    console.error("複製到剪貼簿失敗：", err);
                                                });
                                            }
                                        }}>傳送邀請連結</YStyled.Span>
                                    </div>
                                    <div className={styleUi.subView}>
                                        <YStyled.Label style={{ padding: ".3rem .5rem", borderRadius: "35px", width: "100%" }}>
                                            <YStyled.Input
                                                placeholder="輸入名稱或ID搜尋"
                                                value={searchTerm}
                                                onChange={handleInputChange}
                                            />
                                            {searchTerm !== "" &&
                                                <img src="./assets/ui/close_c.png" onClick={e => {
                                                    setSearchTerm("");
                                                }} />
                                            }
                                        </YStyled.Label>
                                        <div className={styleUi.list}>
                                            {
                                                filterUser.map((v, k) => {
                                                    return <div className={styleUi.item} key={k} onClick={e => {
                                                        addModalType({ cls: "FriendPage", arg: { friendVo: v ,set_friends:set_friends} });
                                                    }}>
                                                        <FriendInfo user={v.user_friends_detail} type={6} />
                                                        {v.user_friends_status === 2 &&
                                                            <YStyled.BTN3 normalBg="#C2A532" hoverBg="#C2A532" style={{ padding: ".4rem 1rem", borderRadius: "10px", borderWidth: "0px" }} onClick={e=>{
                                                                e.stopPropagation();
                                                                console.log("v",v)
                                                                apiManager.fetchDelete(`user/friends/${v.user_friends_detail.user_id}`,{},0).then(res=>{
                                                                    console.log("res",res);
                                                                })
                                                            }}>
                                                                <YStyled.Span size={15} fontWeight={400}>已加入</YStyled.Span>
                                                            </YStyled.BTN3>
                                                        }
                                                        {v.user_friends_status === 1 &&
                                                            <YStyled.BTN3 normalBg="#C2A532" hoverBg="#C2A532" style={{ padding: ".4rem 1rem", borderRadius: "10px", borderWidth: "0px" }} onClick={e=>{
                                                                e.stopPropagation();
                                                                console.log("v",v)
                                                                apiManager.fetchDelete(`user/friends/${v.user_friends_detail.user_id}`,{},0).then(res=>{
                                                                    console.log("res",res);
                                                                })
                                                            }}>
                                                                <YStyled.Span size={15} fontWeight={400}>已傳送</YStyled.Span>
                                                            </YStyled.BTN3>
                                                        }
                                                        {v.user_friends_status === 0 &&
                                                            <YStyled.BTN3 normalBg="#654721" disableBg="#D9D9D9" disabled={false} style={{ padding: ".4rem 1rem", borderRadius: "10px", borderWidth: "0px" }} onClick={e => {
                                                                e.stopPropagation();
                                                                console.log("add friend", v.user_friends_detail.user_id);
                                                                apiManager.fetchPost(`user/friends`, {
                                                                    "user_id": v.user_friends_detail.user_id
                                                                }, 0).then(res => {
                                                                    console.log("res",res)
                                                                    set_friends(prevFriends => {
                                                                        const updatedFriends = [...prevFriends];
                                                                        const targetFriend = updatedFriends.find(friend => friend.user_friends_detail.user_id=== v.user_friends_detail.user_id);
                                                                        if (targetFriend) {
                                                                            targetFriend.user_friends_status=res.user_friends_status;
                                                                        }
                                                                        console.log("updatedFriends",updatedFriends)
                                                                        return updatedFriends;
                                                                    });
                                                                })
                                                            }}>
                                                                <YStyled.Span size={15} fontWeight={400}>加好友</YStyled.Span>
                                                            </YStyled.BTN3>
                                                        }
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(AddFriend);
